import { render, staticRenderFns } from "./ModalDeleteBlockRule.vue?vue&type=template&id=abcc17e4"
import script from "./ModalDeleteBlockRule.vue?vue&type=script&lang=js"
export * from "./ModalDeleteBlockRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports